import { CurrentProfileContext, CurrentUserContext, CurrentUserType } from '@rma/authentication/public/user';
import { CurrentSubscription } from '@rma/billing/subscription-plans/public/api-subscription-features';
import { ProfileType, SubscriptionTiers } from '@rma/generic/domain/to-be-sorted';

export interface FeatureUser {
  key: string;
  email: string;
  name?: string;
  anonymous: boolean;
  firstName?: string;
  lastName?: string;
  avatar: string;
  custom: {
    profileCode?: string;
    profileType?: ProfileType;
    verticalType?: string;
    tier?: SubscriptionTiers;
    usertype?: CurrentUserType;
    isImpersonating?: boolean;
    networkId?: string;
    onTrial?: boolean;
    isSubscribed?: boolean;
    isSubscriptionProvided?: boolean;
  };
}

export function mapDataToFeatureUser(
  profileContext: CurrentProfileContext,
  userContext: CurrentUserContext,
  subscription: CurrentSubscription | null,
): FeatureUser | null {
  if (!userContext) {
    return null;
  }

  return {
    key: userContext.userId,
    email: userContext.email,
    name: userContext.name,
    anonymous: false,
    firstName: userContext.firstname,
    lastName: userContext.lastname,
    avatar: profileContext.profileImage,
    custom: {
      profileCode: profileContext.profileCode,
      profileType: profileContext.profileType,
      verticalType: profileContext.primaryVerticalType,
      tier: subscription?.tier,
      usertype: userContext.userType,
      isImpersonating: userContext.isImpersonating ?? false,
      onTrial: subscription?.onTrial,
      isSubscribed: subscription ? !(subscription.isFree || (subscription.onTrial && !subscription.isSubscribed)) : false,
      isSubscriptionProvided: subscription?.isProvided ?? false,
    },
  };
}
